import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { 
  Home, 
  Swords, 
  User, 
  Wallet, 
  LogOut, 
  Menu, 
  X,
  BarChart3,
  Users,
  Settings,
  Zap
} from 'lucide-react';
import Coin from './Coin';

const Navbar = () => {
  const { user, isAuthenticated, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  // Afficher Accueil seulement pour les admins
  const navItems = user && user.role === 'admin'
    ? [{ name: 'Accueil', path: '/', icon: Home }]
    : [];

  // Afficher le jeu en temps réel seulement pour les admins
  const gameNavItems = user && user.role === 'admin'
    ? [{ name: 'Jeu en Temps Réel', path: '/game', icon: Zap }]
    : [];

  const authNavItems = [
    { name: 'Mes Paris', path: '/my-bets', icon: BarChart3 },
    { name: 'Paiements', path: '/payments', icon: Wallet },
    { name: 'Profil', path: '/profile', icon: User },
  ];

  const adminNavItems = [
  // { name: 'Tableau de bord', path: '/admin', icon: BarChart3 },
  { name: 'Gestion des revenus', path: '/admin/combats', icon: Wallet },
  { name: 'Rapports', path: '/admin/reports', icon: Settings },
  ];

  return (
    <nav className="bg-white shadow-lg border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo et navigation principale */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <Swords className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-gray-900">KokBatay</span>
            </Link>

            {/* Navigation desktop */}
            <div className="hidden md:ml-10 md:flex md:space-x-8">
              {/* Accueil visible seulement pour admin */}
              {navItems.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.name}
                    to={item.path}
                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors duration-200 ${
                      isActive(item.path)
                        ? 'border-primary-500 text-primary-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="w-4 h-4 mr-1" />
                    {item.name}
                  </Link>
                );
              })}
              
              {/* Lien vers le jeu en temps réel visible seulement pour admin */}
              {isAuthenticated && gameNavItems.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.name}
                    to={item.path}
                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors duration-200 ${
                      isActive(item.path)
                        ? 'border-primary-500 text-primary-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="w-4 h-4 mr-1" />
                    {item.name}
                  </Link>
                );
              })}

              {/* Menu admin visible seulement pour admin */}
              {user && user.role === 'admin' && (
                <div className="hidden md:flex md:items-center md:space-x-4 ml-8">
                  {adminNavItems.map((item) => {
                    const Icon = item.icon;
                    return (
                      <Link
                        key={item.name}
                        to={item.path}
                        className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors duration-200 ${
                          isActive(item.path)
                            ? 'border-primary-500 text-primary-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                      >
                        <Icon className="w-4 h-4 mr-1" />
                        {item.name}
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* Menu utilisateur */}
          <div className="flex items-center space-x-4">
            {isAuthenticated ? null : (
              <div className="hidden md:flex md:items-center md:space-x-4">
                <Link
                  to="/login"
                  className="text-gray-500 hover:text-gray-700 px-3 py-2 text-sm font-medium"
                >
                  Connexion
                </Link>
                <Link
                  to="/register"
                  className="btn-primary"
                >
                  Inscription
                </Link>
              </div>
            )}


          </div>
        </div>
      </div>


    </nav>
  );
};

export default Navbar;
// pourquoi